import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-pro/css/all.css'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    current: 'sk'
  },
  iconfont: 'fa',
  options: {
    customProperties: true
  }
})
